import { actions, ChartKeyRequest, ChartStore, CHARTS_STORE_NAME } from './store';
import { frontendActions, LocationType } from '@cmctechnology/webinvest-store-frontend';
import { webTradingApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { Dispatch } from '@reduxjs/toolkit';
import { getConfig } from '@cmctechnology/webinvest-store-frontend';
import { IChartDataVeGet1Response } from './charts/simple/models';
import { SparkChartUtils } from './charts/spark/utils';
import { ISparkChartRequest } from './charts/spark/models';

export const API_NAMES = {
  ChartDataSparkGet1: `ChartDataSparkGet1` // Spark
} as const;

type ResourceKey = number | string;

type StoreDispatch = typeof ChartStore.dispatch;

export const getSparkChartData = (key: ChartKeyRequest) => async (dispatch: StoreDispatch) => {
  const apiName = API_NAMES.ChartDataSparkGet1;
  const request = SparkChartUtils.formChartsApiQuery(key);

  const callChartDataAPI = async () => {
    return webTradingApi(getConfig().stockbrokingApiUrl).send({ [apiName]: request }, false);
  };

  try {
    const response = await frontendActions.apiCall(CHARTS_STORE_NAME, apiName, callChartDataAPI, key)(dispatch);
    const transformed = SparkChartUtils.transformChartResponse(request.Instrument, response as IChartDataVeGet1Response);
    dispatch(
      actions.chartDataUpdated({
        key,
        response: transformed
      })
    );
    return transformed;
  } catch {}
};

export const onPollSparkChart =
  (subscriptions: ResourceKey[] = []) =>
  (dispatch: Dispatch<any>) => {
    subscriptions.forEach((sub) => {
      dispatch(getSparkChartData(sub as ChartKeyRequest));
    });
  };

type Query = ISparkChartRequest | ISparkChartRequest[];

export const subscribeSparkCharts = (location: LocationType, query: Query) => (dispatch: Dispatch<any>) => {
  const resourceKeys = SparkChartUtils.getChartKeysFromQueries(query as ISparkChartRequest);
  dispatch(
    frontendActions.subscribe({
      onPoll: onPollSparkChart,
      location,
      apiName: API_NAMES.ChartDataSparkGet1,
      storeName: CHARTS_STORE_NAME,
      resourceKeys,
      pollTimeout: 10_000
    })
  );
};

export const unsubscribeSparkCharts = (location: LocationType, query: Query) => (dispatch: Dispatch<any>) => {
  const resourceKeys = SparkChartUtils.getChartKeysFromQueries(query as ISparkChartRequest);
  dispatch(
    frontendActions.unsubscribe({
      location,
      apiName: API_NAMES.ChartDataSparkGet1,
      storeName: CHARTS_STORE_NAME,
      resourceKeys
    })
  );
};
